import EnrollmentModel from './enrollment.model';

export default class EnrollmentList {
  constructor() {
    this._existingActiveEnrollments = [];
    this._enrollments = [];
    this._activeInactiveEnrollments = [];
    this._pathwayEnrollmentList = [];
    this._pathwayEnrollments = [];
    this._pathwayNotEnrolledList = [];
  }

  set existingActiveEnrollments(allEnrollments) {
    this._existingActiveEnrollments = [];

    allEnrollments.forEach((enrollment) => {
      if ((enrollment.enrollmentStatus || '').toLowerCase() === 'active') {
        this._existingActiveEnrollments.push(new EnrollmentModel(enrollment));
      }
    });
  }

  get existingActiveEnrollments() {
    return this._existingActiveEnrollments;
  }

  resetActiveInactiveEnrollments() {
    this._activeInactiveEnrollments = [];
  }

  addActiveInactiveEnrollments(enrollment) {
    this._activeInactiveEnrollments.push(enrollment);
  }

  get activeInactiveEnrollments() {
    return this._activeInactiveEnrollments;
  }

  set enrollments(enrollmentList) {
    this._enrollments = [];

    enrollmentList.forEach((enrollmentInfo) => {
      this._enrollments.push(new EnrollmentModel(enrollmentInfo));
    });
  }

  set pathwayEnrollmentList(enrollmentList) {
    this._pathwayEnrollmentList = [];
    enrollmentList.forEach((pathwayInfo) => {
      this._pathwayEnrollmentList.push(pathwayInfo);
    });
  }

  set pathwayEnrollments(enrollmentList) {
    this._pathwayEnrollments = [];

    enrollmentList.forEach((pathwayEnrollmentInfo) => {
      this._pathwayEnrollments.push(pathwayEnrollmentInfo);
    });
  }

  get enrollments() {
    return this._enrollments;
  }

  get courseListPageData() {
    return this._enrollments.map((enrollments) => {
      return enrollments.courseListPageData;
    });
  }

  get dashboardPageData() {
    return {
      enrollments: this._enrollments
    };
  }

  get allActiveInactiveEnrollments() {
    return this._enrollments.filter((enrollment) => {
      return ['active', 'inactive'].indexOf((enrollment._enrollmentStatus || '').toLowerCase()) > -1;
    });
  }
}
